export default "__VITE_ASSET__BS5_gH7a__"